export default __webpack_public_path__ + "static/media/SecondBurn.11bffeb4.svg";